import { chanceToBeatControl } from 'cio/helpers/cio-math';
import { ActionType } from 'cio/models/action';
import { SplitMetric } from 'cio/utils/metrics/models/split-metric';
import { Measure, SplitMetricMeasure } from './common';
import { findDenominator, MeasureType } from './measure';

export function calculateCTBOForMeasure(
  original: SplitMetric,
  variation: SplitMetric,
  measure: SplitMetricMeasure,
  actionType?: ActionType,
): number | null {
  let originalMeasure = original[measure];
  let variationMeasure = variation[measure];

  if (!originalMeasure || !variationMeasure) {
    return null;
  }

  let originalMeasureTotal = originalMeasure.rawTotal;
  let variationMeasureTotal = variationMeasure.rawTotal;

  let denominator = findDenominator(measure as Measure, MeasureType.DeliveryMetrics, actionType) as SplitMetricMeasure;

  if (!denominator) {
    return null;
  }

  let originalDenominator = original[denominator];
  let variationDenominator = variation[denominator];

  if (!originalDenominator || !variationDenominator) {
    return null;
  }

  let originalDenominatorTotal = originalDenominator.rawTotal ?? 0;
  let variationDenominatorTotal = variationDenominator.rawTotal ?? 0;

  let chance = chanceToBeatControl(
    originalMeasureTotal,
    variationMeasureTotal,
    originalDenominatorTotal,
    variationDenominatorTotal,
  );

  if (isNaN(chance)) {
    return null;
  }

  return chance;
}
